import { useContext } from 'react';

import { Elements } from '@stripe/react-stripe-js';

import { ProvidersLibsContext } from '@/services/providersLibs/providersLibsContext';

function StripeContainer({ children, enabled }: React.PropsWithChildren<{ enabled: boolean }>) {
  const providersLibs = useContext(ProvidersLibsContext);

  const stripePromise = providersLibs?.stripePromise;

  if (!enabled || !stripePromise) {
    return children;
  }

  return (
    <Elements stripe={stripePromise}>
      {children}
    </Elements>
  );
}

export default StripeContainer;
